<template>
    <v-menu
      ref="menu"
      v-model="clonedField.menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          prepend-icon="mdi-calendar"
          v-model="dateFormatted"
          @blur="newValue = parseDate(dateFormatted)"
          hide-details
          outlined
          dense
          clearable
          :rules="field.rules"
          :disabled="clonedField.disabled"
          :label="clonedField.label"
          :placeholder="clonedField.placeholder"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        ref="picker"

        v-model="newValue"
        :max="new Date().toISOString().substr(0, 10)"
        no-title
        scrollable
        @change="save"
      ></v-date-picker>
    </v-menu>
</template>
<script>
import { utils } from '@/mixins/index';

export default {
  name: 'SearchDatePicker',
  props: [
    'field', 'value'
  ],
  mixins: [utils],
  data: function () {
    return {
      newValue: this.$props.value,
      dateFormatted: this.formatDate(this.$props.value),
      clonedField: this.cloneObject(this.$props.field), // Clone because we need diferent object for the different menu states
      componentType: 'v-date-picker',
      showDatePicker: true
    };
  },
  methods: {
    formatDate (date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;

      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    save (date) {
      this.$refs.menu.save(date);
    }
  },
  watch: {
    newValue (val) { // Updates v-model on the parent
      this.dateFormatted = this.formatDate(val);
      this.$emit('input', val);
    },
    'clonedField.menu' (val) {
      console.log(val, this.$refs);
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'), 100);
    }
  }
};
</script>
